export default "__VITE_ASSET__CkHdnobw__"